import { z } from "zod";

import { RoleResourceTypeSchema } from "../../../../shared/domain/roles/role.types";
import { RoleResourceAccessRequestStatusSchema } from "../../../../shared/domain/roles/role-membership.types";
import { RoleResourceRefInputSchema } from "./core";

/**
 * Resource-access-request schemas — a member asking for access to one of a
 * Role's resources, and an admin reviewing that request.
 */

/** A member's request for access to one of the Role's resources — a real object with a lifecycle, not a boolean. */
export const RoleResourceAccessRequestSchema = z.object({
  id: z.string(),
  roleId: z.string(),
  organizationId: z.string(),
  requestedByUserId: z.string(),
  resourceType: RoleResourceTypeSchema,
  resourceId: z.string(),
  status: RoleResourceAccessRequestStatusSchema,
  note: z.string().nullable(),
  reviewedByUserId: z.string().nullable(),
  reviewedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string()
});

export type RoleResourceAccessRequest = z.infer<typeof RoleResourceAccessRequestSchema>;

export const RoleResourceAccessRequestsListResponseSchema = z.object({
  requests: z.array(RoleResourceAccessRequestSchema)
});

export const RoleResourceAccessRequestCreateBodySchema = RoleResourceRefInputSchema.extend({
  note: z.string().max(2000).nullable().optional()
});

export const RoleResourceAccessRequestPathVarsSchema = z.object({
  id: z.string().uuid(),
  requestId: z.string().uuid()
});

/** Admins reviewing a queue filter to PENDING; omit for every status. */
export const RoleResourceAccessRequestListQuerySchema = z.object({
  status: RoleResourceAccessRequestStatusSchema.optional()
});

/** Only APPROVED/REJECTED are valid review outcomes — PENDING is the starting state, never a target. */
export const RoleResourceAccessRequestReviewBodySchema = z.object({
  status: z.enum(["APPROVED", "REJECTED"])
});
